var render = function render(){var _vm=this,_c=_vm._self._c;return _c('account-background',{attrs:{"product-name":_vm.productName,"theme-colour":_vm.themeColour,"id":"forgot-password-background"}},[_c('forgot-password-box',{staticClass:"mb-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }